<template>
  <div id="LibraryDel">

    <Head />
    <img :src="imgs[id].src" alt />
    <Foot />
  </div>
</template>

<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
export default {
  data() {
    return {
      imgs: [
        {
          src: require("../assets/Index/大型煤企产销协同管理实践—淮南矿业（集团）有限责任公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/大型能源集团产融大数据分析平台建设探索及实践—国家能源集团神华财务有限公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/以信息化、标准化为基础-煤炭定制化生产模式研究与应用—国家能源集团公司煤炭产业运营管理中心—1-1.jpg")
        },
        {
          src: require("../assets/Index/国有大型能源化工集团改革路径的设计与实践—中国平煤神马能源化工集团有限责任公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/煤炭集团企业财务共享中心实践—河南能源义马煤业集团股份有限公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/基于复杂生产经营条件下的煤炭企业精益管理—山东能源淄博矿业集团有限责任公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/煤矿“三链五全”价值链管理体系的构建与实施—山东能源枣庄矿业（集团）高庄煤业有限公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/煤炭企业集团供应链管理的研究与实施—山东能源枣庄矿业（集团）有限责任公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/煤炭企业推进“自动化、信息化、智能化”融合发展的研究与实践—兖矿集团有限公司—1-1.jpg")
        },
        {
          src: require("../assets/Index/煤炭交易大数据平台建设—中国（太原）煤炭交易中心—1-1.jpg")
        },
        {
          src: require("../assets/Index/无.jpg")
        }
      ],
      id: ""
    };
  },
  created() {
    if (this.$route.query.id > 9) {
      this.id = 10;
    } else {
      this.id = this.$route.query.id;
    }

    console.log(this.id);
  },
  components: {
    Head,
    Foot
  }
};
</script>

<style lang="less" scoped>
#LibraryDel {
  width: 100%;
  min-width: 1000px;

  img {
    width: 19rem;
  }
}
</style>

